const SearchLoadingIndicator = () => {
  // hide the loading indicator for the search input
  return null;
};
export default SearchLoadingIndicator;